function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'b59f8f3854abf10b87093d912a936377': 'rgb(0, 0, 0)','6403558c0e945a72056d09ac3281f964': 'rgb(255, 255, 255)','4d9ad661c53222023932665b4a2a4f6d': 'rgb(128, 128, 128)','ba5b061875703f680449f47a512be4e0': 'rgb(211, 211, 211)','9ca1af4d4bc551a02d939f831cf9df4b': 'rgb(0, 0, 128)','3b24fa7e14555a1912e5bc2198f8e075': 'rgb(0, 0, 255)','9a5ec59cdb51279d3c6dfc25062ea0e1': 'rgb(173, 216, 230)','92c4cf9df4c01b73f7e757e78ae60841': 'rgb(255, 0, 0)','1f8090da94a8c107cb302858b891569f': 'rgb(128, 0, 0)','dcf782ec4a7c9eb2230e7d74081ff226': 'rgb(255, 192, 203)','8e09cd128361c6a3935481f40814eca2': 'rgb(255, 0, 255)','c0bc9058dd3d8b2253e64987eb9d821f': 'rgb(128, 128, 0)','d4177dc752cddc204b22ec5798c4400e': 'rgb(0, 128, 0)','b71d472fff25a5ed3f4f95ab5c9433c9': 'rgb(152, 255, 152)','efc5f4b470619b932aed03953e50ce60': 'rgb(245, 245, 220)','07117fe4a1ebd544965dc19573183da2': 'rgb(139, 69, 19)','a4995d016a80cf2321cda0ab1a966935': 'rgb(193, 154, 107)','49fad65a2af39b39ae1de528b4eaab17': 'rgb(255, 219, 88)','1ef4674feb1ddc81d2b8fc2b3c3878f2': 'rgb(255, 255, 0)','091808fcfe95ad6473dec65aedd05e90': 'rgb(255, 165, 0)','70bf419a95ffb92216cb07b889fdfb12': 'rgb(230, 230, 250)','fda6ef9f6ba8382c875468cd70d33ecf': 'rgb(200, 162, 200)','17163859b9c16bc4dec286e3adc20047': 'rgb(128, 0, 128)',};

    this.images = {};
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
